var _path, _path2;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgJobs02 = function SvgJobs02(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "currentColor",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22,12H14v1.4798H10V12H2a2.98844,2.98844,0,0,1-2-.7749v8.79571A1.99553,1.99553,0,0,0,2,22H22a1.99553,1.99553,0,0,0,2-1.97919V11.2251A2.98844,2.98844,0,0,1,22,12Z",
    transform: "translate(0 -1)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22,5H16V2a1,1,0,0,0-1-1H9A1,1,0,0,0,8,2V5H2A1.99554,1.99554,0,0,0,0,6.97919V9.02081A1.99553,1.99553,0,0,0,2,11h8v-.4798h4V11h8a1.99553,1.99553,0,0,0,2-1.97919V6.97919A1.99554,1.99554,0,0,0,22,5ZM15,5H9V3h6Z",
    transform: "translate(0 -1)"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgJobs02, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/jobs02.2a3e7622.svg";
export { ForwardRef as ReactComponent };